import { render, staticRenderFns } from "./VisitSystem.vue?vue&type=template&id=4a0fc01c&"
import script from "./VisitSystem.vue?vue&type=script&lang=js&"
export * from "./VisitSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports